export const OOB_MODEL_SHORT_CODES = ["assets", "vendors", "contacts", "data-sets", "processes", "policies", "patterns", "templates", "contracts"];
export const isOutOfBox = (shortCode) => OOB_MODEL_SHORT_CODES.includes(shortCode);

export const MODEL_TYPES = {
  LIST: "list",
  LIBRARY: "library",
};
